import React, { PropsWithChildren } from "react";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export const TableContainer = ({ children }: PropsWithChildren<{}>) => (
  <Box sx={{ display: "grid", gridTemplateRows: "auto 1fr", overflowY: "auto", outline: `1px solid ${grey["300"]}` }}>
    {children}
  </Box>
);
